/* global google, GMaps, Rydges */

import axios from 'axios';
import qs from 'qs';
import * as constants from '../../util/constants';

const thingsToDoMap = () => {
  jQuery(document).ready(function($) {
    // Init GMAP and set Markers
    if ($('#map').length) {
      // Init map on AU
      const map = new GMaps({
        div: '#map',
        scrollwheel: false,
        lat: -25.8334694,
        lng: 132.5673494,
        zoom: 5,
      });

      // Center view on first marker
      let focusOnce = false;
      map.on('marker_added', (marker) => {
        if (!focusOnce && map.markers.length <= 1) {
          const index = map.markers.indexOf(marker);
          const position = map.markers[index].getPosition();
          const lat = position.lat();
          const lng = position.lng();
          map.setCenter(lat, lng);
          map.setZoom(13);
          focusOnce = true;
        }
      });

      // Fetch things to do
      axios.post(window.Rydges['ajaxUrl'], qs.stringify({
        'action': constants.ACTION_GET_THINGS_TO_DO,
      })).then((response) => {

        const hasData = response.data.success &&
          response.data.data &&
          response.data.data.todos.length > 0;

        if (hasData) {
          // Cache hotel info
          this.hotel_info = response.data.data.hotel_info;

          const types = [
            { name: 'All', color: '#871c3c' },
            ...response.data.data.types,
          ];

          const thingsToDo = response.data.data.todos;

          // Display things to do types and cards
          const categoryList = $('.things-to-do-list-wrapper .category-list');
          const loadMoreBtn = $('.things-to-do-list-wrapper .btn-load-more');

          const categories = types.reduce((categories, category) => {
            categories += `<a
              data-name="${category.name}"
              data-color="${category.color}"
              style="
                border: 1px solid ${category.color};
                color: ${category.color};
                cursor: pointer;
              ">
              ${category.name}
            </a>`;

            return categories;
          }, '');

          categoryList.append(categories);
          loadMoreBtn.prop('disabled', false);

          // Show only few cards
          this.loadedThingsToDoCards = 9;

          let activeCategory = types[0];

          categoryList.on('click', 'a', (event) => {
            const elem = event.currentTarget;

            const category = elem.dataset;
            if (activeCategory.name.toLowerCase() === category.name.toLowerCase()) {
              return;
            }

            unhighlightCategory(activeCategory);

            activeCategory = category;

            this.loadedThingsToDoCards = 9;

            displayPinsAndCards(thingsToDo, activeCategory, map);
            highlightCategory(activeCategory);
          });

          loadMoreBtn.on('click', (event) => {
            event.preventDefault();

            this.loadedThingsToDoCards += 9;

            displayPinsAndCards(thingsToDo, activeCategory, map);
          });

          // Display things to do pins and cards
          displayPinsAndCards(thingsToDo, activeCategory, map);
          highlightCategory(activeCategory);
        }

      }).catch((error) => {
        console.log(error);
      });
    }

    const unhighlightCategory = (category) => {
      $(`.things-to-do-list-wrapper .category-list
        a[data-name='${category.name}']`).css({
        'background-color': 'transparent',
        'color': category.color,
      });
    };

    const highlightCategory = (category) => {
      $(`.things-to-do-list-wrapper .category-list
        a[data-name='${category.name}']`).css({
        'background-color': category.color,
        'color': 'white',
      });
    };

    const getCardItem = (todo, show = true) => {
      return `<div class="col-12 col-md-6 col-lg-4 ttd-col mb-4 ${show ? 'd-block' : 'd-none'}">
        <a class="ttd-card d-flex align-items-center" href="${todo.href}">
          <div class="ttd-image mr-3"
            style="background-image: url(${todo.img})">
          </div>
          <div class="ttd-info-wrapper">
            <div class="ttd-info mb-3">
              <div class="ttd-name">
                ${todo.name}
              </div>
              <div class="ttd-date">
                ${todo.date}
              </div>
            </div>
            <div class="tag" style="background-color: ${todo.type.color}">
              ${todo.type.name}
            </div>
          </div>
        </a>
      </div>`;
    };

    const transformMapInfo = (data, template) => {
      const keys = [];
      const values = [];
      $.each(data, function (key, value) {
        keys.push(key);
        values.push(value);
      });
      for (let i = 0; i < keys.length; i++) {
        template = template.replace(new RegExp('--' + keys[i] + '--', 'g'), values[i]);
      }
      return template;
    };

    const displayPins = (map, pins) => {
      map.removeMarkers();

      // Add hotel pin
      const template = $('#map-markers').html();
      const pin = {
        lat: this.hotel_info.lat,
        lng: this.hotel_info.lng,
        title: this.hotel_info.name,
        icon: {
          scaledSize: new google.maps.Size(
            this.hotel_info.custom_pin.width,
            this.hotel_info.custom_pin.height
          ),
          url:  this.hotel_info.custom_pin.url,
        },
        infoWindow: {
          'content': transformMapInfo({
            name: this.hotel_info.name,
            address: this.hotel_info.address,
          }, template),
          // 'pixelOffset': new google.maps.Size(100, 20),
        },
        click() {
          setTimeout(() => {
            // Remove info window arrow
            const gmStyleIw = $('.gm-style-iw');
            const gmArrow = gmStyleIw.prev().find('div').eq(2);
            gmArrow.parent().find('div').eq(0).hide();
            gmArrow.hide();
          }, 10);
        },
      };
      map.addMarker(pin);

      map.addMarkers(pins);
    };

    const displayCards = (cards) => {
      const list = $('.things-to-do-list-wrapper .things-to-do-list');

      $(list).empty();
      $(list).append(cards);
    };

    const displayPinsAndCards = (thingsToDo, type, map) => {
      const template = $('#map-markers').html();

      const todos = type.name.toLowerCase() === 'all'
        ? thingsToDo
        : thingsToDo.filter((todo) => todo.type.name.toLowerCase() === type.name.toLowerCase());

      const [cards, pins] = todos.reduce(([cards, pins], todo, index, arr) => {
        const pin = {
          lat: todo.lat,
          lng: todo.lng,
          title: todo.name,
          icon: (todo.hasOwnProperty('custom_pin') && todo.custom_pin !== '')
            ? {
              scaledSize: new google.maps.Size(
                todo.custom_pin.width,
                todo.custom_pin.height
              ),
              url: todo.custom_pin.url,
            }
            : undefined,
          infoWindow: {
            'content': transformMapInfo({
              name: todo.name,
              address: todo.address,
            }, template),
            // 'pixelOffset': new google.maps.Size(100, 20),
          },
          click() {
            setTimeout(() => {
              // Remove info window arrow
              const gmStyleIw = $('.gm-style-iw');
              const gmArrow = gmStyleIw.prev().find('div').eq(2);
              gmArrow.parent().find('div').eq(0).hide();
              gmArrow.hide();
            }, 10);
          },
        };

        const loadMoreBtn = $('.things-to-do-list-wrapper .btn-load-more');
        const showCard = this.loadedThingsToDoCards > index;

        if (this.loadedThingsToDoCards >= arr.length) {
          loadMoreBtn.prop('disabled', true);
          loadMoreBtn.html('That\'s All');
        } else {
          loadMoreBtn.prop('disabled', false);
          loadMoreBtn.html('Load More');
        }

        pins.push(pin);
        cards += `${getCardItem(todo, showCard)}`;

        return [cards, pins];
      }, [ '', []]);

      displayPins(map, pins);
      displayCards(cards);
    };
  });
};

export default thingsToDoMap;



// WEBPACK FOOTER //
// ./scripts/routes/modules/thingsToDoMap.js